module.exports = __webpack_public_path__ + "img/report-expand.70ffd0f8.png";